import { render } from "./setalert.vue?vue&type=template&id=48a70bb2&scoped=true"
import script from "./setalert.js?vue&type=script&lang=js"
export * from "./setalert.js?vue&type=script&lang=js"

import "./setalert.vue?vue&type=style&index=0&id=48a70bb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a70bb2"]])

export default __exports__